<template>
  <div>
    <h4>{{ $t('idenForm.appForm.noticeMessage' )}}</h4>
    <div class="touchID">
      <img src="@/assets/image/touchID.png" :alt="$t('idenForm.touchIcon.alt')">
    </div>
    <div class="limited-massage">
    </div>
    <div class="div_btn">
      <button class="btn_submit" @click="idenProcess" :disabled="!isRequested">{{ $t('idenForm.btnSubmit') }}</button>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import * as AuthApi from '@/api/auth';

export default {
  name: 'idenAppForm',
  components: {
  },
  data: () => ({
    isRequested: false,
  }),
  methods: {
    idenReqProcess(){
      this.popWait();
      AuthApi.req2nd().then((e) => {
        if(e.status === 200){
          this.isRequested = true;
          return Promise.resolve();
        } else {
          return Promise.reject(e);
        }
      })
      .catch((e) => {
        let text = this.$t('idenForm.appForm.error.check2ndFailed');

        if(e.data){
          if(e.data.result === -200){
            text = this.$t('idenForm.appForm.error.noSign');
          } else if(e.data.description){
            text = e.data.description;
          }
        }

        this.popAlert({ text })
        .then(() => { this.$emit('failed'); });
      })
      .finally(() => {
        this.stopWait();
      })
    },
    idenProcess(){
      this.popWait();
      AuthApi.getResult2nd().then((e) => {
        console.log(e);
        if(e.status === 200){
          return Promise.resolve(e.data+"");
        } else {
          this.popAlert('idenForm.appForm.error.check2ndFailed');
        }
      })
      .then((code) => {
        switch (code) {
          case '0': // 진행중
            this.popAlert('idenForm.appForm.error.proceeding');
            break;
          case '1': // 성공
            this.$emit('success');
            break;
          case '2': // 취소
            this.popAlert('idenForm.appForm.error.cancel')
            .then(() => { this.$emit('failed'); });
            break;
          case '3': //실패
            this.popAlert('idenForm.appForm.error.failed')
            .then(() => { this.$emit('failed'); });
            break;
          case '4': //차단
            this.popAlert('idenForm.appForm.error.blocked')
            .then(() => { this.$emit('failed'); });
            break;
          default: //기타
            this.popAlert('idenForm.appForm.error.check2ndFailed')
            .then(() => { this.$emit('failed'); });
        }
      })
      .finally(() => {
        this.stopWait();
      })
    },
    ...mapActions([
      'popAlert',
      'popWait',
      'stopWait',
    ]),
  },
  mounted(){
    this.idenReqProcess();
  },
  computed: {
  },
};
</script>
<style lang="scss" scoped>
  h4 {
    margin-top: 80px;
    margin-bottom: 40px;
    text-align: center;
    color: #555;
    font-weight: 400;
  }
  .touchID {
    width: 130px;
    height: 130px;
    margin: 0 auto;
  }

  .limited-massage{
    padding: 20px 0px 100px 0px;
    height: 30px;
    display: flex;
    justify-content: center;
  }

  .div_btn {
    display: flex;
    gap: 0px 5px;

    .btn_submit {
      display: block;
      width: 100%;
      height: 40px;
      margin: 0 auto;
      background-color: #0059a9;
      color: #fff;
      text-align: center;
      transition: 0.3s;
      font-size: 12pt;
      cursor: pointer;
      &:hover {
        background-color: #004788;
      }
      &:disabled {
        background-color: #eee;
        color: #555;
      }
    }
  }


</style>
